import $ from 'jquery';
import whenDomReady from 'when-dom-ready';
import TicketsocketCookie from './TicketsocketCookie';
import TicketCart from '../tsx/TicketCart';
import MobileTicketButton from '../tsx/MobileTicketButton';
/*
 * Entry point for cart ticket logic
 *
 * author: nick.arcuri@spartan.com
 *
 */
whenDomReady(function () {
    var $raceCartWrapper = $('#race-cart-wrapper');
    var tickets = TicketsocketCookie.data;
    console.log('TICKET COOKIE: ', tickets);
    if (tickets === null || tickets === void 0 ? void 0 : tickets.length) {
        var $body = $('body');
        var overlayClass = 'ticket-cart__overlay';
        var $ticketOverlay_1 = $("<div class=\"" + overlayClass + "\"></div>");
        $body.prepend($ticketOverlay_1);
        // Show race ticket icon
        $raceCartWrapper.addClass('show');
        $raceCartWrapper.find('.qty-indicator').html(tickets.length);
        // Add tsx
        var ticketCart = TicketCart(tickets);
        var mobileTicketButton = MobileTicketButton(tickets, $raceCartWrapper.data('ticket-icon'));
        var $ticketCart = $(ticketCart);
        $raceCartWrapper.append($ticketCart);
        document.body.append(mobileTicketButton);
        $(".race-ticket-icon, #race-cart-wrapper .qty-indicator, ." + overlayClass).click(function () {
            $raceCartWrapper.toggleClass('show-cart');
            $ticketOverlay_1.toggleClass('show');
        });
    }
});
